<nz-spin [nzSpinning]="loading">
<div class="selection-dialog">

  <!-- HEADER ACTIONS -->
  <div class="search-row">

    <!-- NON-HSCODE: original behaviour unchanged -->
    <ng-container *ngIf="controlType?.toLowerCase() !== 'hscode'">
      <div class="hs-search-inputs">
        <label *ngIf="isMultiple && !isPair && module == 'risk'" nz-checkbox [(ngModel)]="isFavouriteMode" (ngModelChange)="checkUncheckFav()" class="fav-checkbox-inline">
          {{ isFavouriteMode ? 'Hide Favourite List' : 'Load from Favourite List' }}
        </label>
        <ng-container *ngIf="!isFavouriteMode">
          <nz-input-group nzPrefixIcon="search" class="flex-1">
            <input nz-input placeholder="Search..." [(ngModel)]="searchText" (keyup.enter)="onSearch()" />
          </nz-input-group>
        </ng-container>
        <ng-container *ngIf="isFavouriteMode && module == 'risk'">
          <nz-select nzPlaceHolder="Select Favorite" [(ngModel)]="selectedFavourite" (ngModelChange)="onFavouriteChange($event)" class="fav-select">
            <nz-option *ngFor="let fav of favouriteList" [nzLabel]="fav.favouriteListName" [nzValue]="fav"></nz-option>
          </nz-select>
        </ng-container>
      </div>
    </ng-container>

    <!-- HSCODE: new layout -->
    <ng-container *ngIf="controlType?.toLowerCase() === 'hscode'">

      <div class="hs-search-inputs">
        <label *ngIf="isMultiple && !isPair && module == 'risk'" nz-checkbox [(ngModel)]="isFavouriteMode" (ngModelChange)="checkUncheckFav()" class="fav-checkbox-inline" tabindex="1">
          {{ isFavouriteMode ? 'Hide Favourite List' : 'Load from Favourite List' }}
        </label>
        <ng-container *ngIf="!isFavouriteMode">
          <nz-select nzPlaceHolder="Search Chapter Code" [(ngModel)]="chapterSearch" [nzShowSearch]="true" [nzAllowClear]="true" nzMode="multiple" class="flex-full" [attr.tabindex]="2">
            <nz-option *ngFor="let option of chapterCodeList" [nzLabel]="option.code + ' - ' + option.label" [nzValue]="option.code"></nz-option>
          </nz-select>
           <button nz-button nzType="primary" nz-tooltip nzTooltipTitle="Search" (click)="onSearch()" [disabled]="!hasHsSearchValue" tabindex="4"><span nz-icon nzType="search"></span></button>
        </ng-container>
        <ng-container *ngIf="isFavouriteMode && module == 'risk'">
        <nz-select nzPlaceHolder="Select Favorite" [(ngModel)]="selectedFavourite" (ngModelChange)="onFavouriteChange($event)" class="fav-select">
          <nz-option *ngFor="let fav of favouriteList" [nzLabel]="fav.favouriteListName" [nzValue]="fav"></nz-option>
        </nz-select>
      </ng-container>
      </div>
      <div *ngIf="!isFavouriteMode" class="hs-search-inputs">
        <input nz-input placeholder="Search by HS Code" [(ngModel)]="hsCodeSearch" tabindex="2" />
        <input nz-input placeholder="Search by Description" [(ngModel)]="descriptionSearch" tabindex="3" />
        <button nz-button nz-tooltip nzTooltipTitle="Reset" (click)="onHsSearchReset()" [disabled]="!hasHsSearchValue" tabindex="5"><span nz-icon nzType="close"></span></button>
      </div>

    </ng-container>

  </div>
  <!-- /HEADER ACTIONS -->

  <!-- TABLE -->
  <nz-table class="declaration-table" [nzData]="filteredData" [nzScroll]="{ y: '250px;'}" [nzFrontPagination]="false" nzSize="middle">
    <thead>
      <tr *ngIf="this.controlType?.toLowerCase() !== 'hscode'">
        <th nzWidth="40px" *ngIf="!isFavouriteMode;">
          <label *ngIf="isMultiple;" nz-checkbox [ngModel]="allChecked" [nzIndeterminate]="indeterminate" (ngModelChange)="checkAll($event)"></label>
          <label *ngIf="!isMultiple;"></label>
        </th>
        <th>CODE</th>
        <th>Description</th>
      </tr>
      <tr *ngIf="this.controlType?.toLowerCase() == 'hscode'">
        <th nzWidth="40px" *ngIf="!isFavouriteMode;">
          <label *ngIf="isMultiple;" nz-checkbox [ngModel]="allChecked" [nzIndeterminate]="indeterminate" (ngModelChange)="checkAll($event)" tabindex="6"></label>
          <label *ngIf="!isMultiple;"></label>
        </th>
        <th nzWidth="15%">CODE</th>
        <th nzWidth="70%">Description</th>
        <th nzWidth="15%">UOM</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of filteredData">
        <td *ngIf="isMultiple && !isFavouriteMode">
          <label nz-checkbox [(ngModel)]="item.checked" (ngModelChange)="refreshStatus($event, item)" tabindex="7"></label>
        </td>
        <td *ngIf="!isMultiple">
          <nz-radio-group *ngIf="!isMultiple" [(ngModel)]="selectedValue" (ngModelChange)="onRadioChange(item)">
            <label nz-radio [nzValue]="item.code" [id]="item.code" tabindex="8"></label>
          </nz-radio-group>
        </td>
        <td>{{ item.code }}</td>
        <td>{{ item.label }}</td>
        <td *ngIf="this.controlType?.toLowerCase() === 'hscode'">{{ item.uom }}</td>
      </tr>
    </tbody>
  </nz-table>

  <div class="mt-md pagination-row" *ngIf="total > 0">
    <div>
      <nz-pagination [(nzPageIndex)]="pageIndex" [nzTotal]="total" [nzPageSize]="pageSize" (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
    </div>
    <div>
      <span class="mr-sm">Go to:</span>
      <input nz-input [(ngModel)]="gotoPageNumber" placeholder="Page" type="number" [min]="1" [max]="maxPages" class="goto-input mr-sm" (keyup.enter)="goToPage()" />
      <button nz-button nzType="primary" (click)="goToPage()" [disabled]="!gotoPageNumber">Go</button>
    </div>
  </div>

  <div class="footer">
    <div class="btn-wrapper">
      <button nz-button (click)="closeModal()">Cancel</button>
      <button *ngIf="isPair" nz-button class="btn-back" (click)="goBack()">
        Back To HS Code Mapping
      </button>
      <button nz-button class="btn-primary" (click)="confirmSelection()"
        [disabled]="isMultiple ? !selectedValues.length : !selectedValue">
        Apply
      </button>
    </div>
  </div>

</div>
</nz-spin>
